import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-spinning-loader',
    templateUrl: './spinning-loader.component.html',
    standalone: false
})
export class SpinningLoaderComponent implements OnInit
{
    @Input() shown: boolean;
    @Input() text: string;

    constructor() { }

    ngOnInit ()
    {
    }
}
